import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { v4 as uuid } from "uuid";
import { cn } from "@/lib/utils";
interface TextareaWrapperProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  labelText?: string;
  isElementValid?: boolean;
  isElementTouched?: boolean;
}
const TextareaWrapper = React.forwardRef<HTMLTextAreaElement, TextareaWrapperProps>(({
  labelText,
  ...props
}, ref) => {
  const textareaId = props.id || uuid();
  return <div className="relative">
        {/* Pass the ref to the underlying Textarea component */}
        <Textarea {...props} id={textareaId} ref={ref} className="peer" />
        {!!labelText && <label htmlFor={textareaId} className={cn("pointer-events-none absolute -top-2.5 left-1 z-10 origin-[0] translate-y-0 scale-75 select-none rounded-md bg-background px-2 text-sm text-foreground/80 duration-300 peer-placeholder-shown:translate-y-5 peer-placeholder-shown:scale-100 peer-focus:-translate-y-0 peer-focus:scale-75 peer-focus:px-2 peer-focus:font-semibold peer-focus:text-glow", props.isElementValid && !props.disabled ? "text-green-500" : props.isElementTouched ? "text-red-500" : "")}>
            {labelText}
          </label>}
      </div>;
});
TextareaWrapper.displayName = "TextareaWrapper";
export default TextareaWrapper;